export default __webpack_public_path__ + "static/media/feature--hero-lg.c0b3d514.png";